import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { Text } from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const LabelBlock = ({ lableTitle }) => (
  <div className={cn('label')}>
    <Text size="size7-r">
      {lableTitle}
    </Text>
  </div>
);

LabelBlock.propTypes = {
  lableTitle: PropTypes.string,
};

export { LabelBlock };
